import React from 'react';
import WmsButton from '../components/WmsButton/WmsButton.jsx';
import WmsDropdown from '../components/WmsDropdown/WmsDropdown.jsx';
import WmsCollapse from '../components/WmsCollapse/WmsCollapse.jsx';
import WmsConfirmModel from '../components/WmsConfirmModel/WmsConfirmModel.jsx';
import { SmallParcelCarrierAccountSettings } from './carrierAccount/small-parcel-carrier-account-settings.component.jsx';
import { SmallParcelSmartSettings } from './smartSettings/small-parcel-smart-settings.component.jsx';
//services
import * as GlobalService from '../global_services';
import './small-parcel-settings.scss';

//services
import * as smallParcelServices from './small-parcel-settings.services.jsx';
import * as GridConfig from './smartSettings/small-parcel-smart-settings-config.jsx';

export class SmallParcelSettingsHolder extends React.Component {

    constructor(props) {
        super(props);
        this.translate = window.translate;
        this.$rootScope = window;
        this.customLabels = GlobalService.getCustomLabels();
        this.windowId = this.$rootScope.ChildBulletin.Data.Window;
        this.sharedFacilityOption = GlobalService.getFacilityList(false);
        this.optionsCustomer = GlobalService.getCustomerList(false);
        this.selector = 'SmallParcelSettings';
        this.USPSCarriers = ["stamps.com", "endicia", "buku", "pitneybowesexp"];

        this.rights = GlobalService.GetRights();
        this.isEnableProvider = this.rights.hasOwnProperty('Shipping.SmallParcelEnabled') && this.rights['Integrations.SmallParcelPartner'] == 'ParcelApi';
        this.state = {
            settingsSaveLoading: false,
            isOpenConfirmModel: false,
            isFormDataChanged: false,
            sharedSmallParcelSettings: {
                carrierFedEx: [],
                carrierUPS: [],
                AutoRateShoppingMapping: '',
                AutoRateShoppingLogic: '',
            },
            selectedCustomerIndex: '',
            selectedCustomerObj: {},
            carrierAccountsGridData: [],
            sharedShipEngineCarrier: []
        }
    }

    // Helper function to remove special characters from string
    removeSpecialCharacters = (str) => {
        if (!str) return '';
        return str.replace(/[^a-zA-Z0-9]/g, '');
    }

    normalizeCarrierKeyForRateShop = (name) =>
        (name || '').toLowerCase().replace(/\s+/g, '_');

    stripAlnumForRateShop = (str) =>
        (str || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();

    gridRowMatchesSchemaCarrierEntry = (row, providerName, schemaCarrierKey, carrierDef) => {
        if (!row.Carrier) return false;
        if (row.Provider && row.Provider !== providerName) return false;
        const keyNorm = this.normalizeCarrierKeyForRateShop(schemaCarrierKey);
        const display = row.Carrier;
        if (this.normalizeCarrierKeyForRateShop(display) === keyNorm) return true;
        if (
            carrierDef.carrierName &&
            display.toLowerCase() === String(carrierDef.carrierName).toLowerCase()
        ) {
            return true;
        }
        if (
            carrierDef.carrierNameAliases &&
            carrierDef.carrierNameAliases.some(
                (alias) => display.toLowerCase() === String(alias).toLowerCase()
            )
        ) {
            return true;
        }
        return this.stripAlnumForRateShop(display) === this.stripAlnumForRateShop(schemaCarrierKey);
    };

    getSchemaCarrierKeysForGridRow = (row) => {
        const schema = GlobalService.GetDynamicCarrierAccountSchema();
        const keys = new Set();
        if (!schema || !row?.Carrier) return keys;
        for (const providerName in schema) {
            const tmpCarriers = schema[providerName]?.carriers;
            if (!tmpCarriers) continue;
            for (const carrierKey in tmpCarriers) {
                const carrierDef = tmpCarriers[carrierKey];
                if (this.gridRowMatchesSchemaCarrierEntry(row, providerName, carrierKey, carrierDef)) {
                    keys.add(carrierKey);
                }
            }
        }
        return keys;
    };

    legacyRateShoppingIdToGridCarrierLabel = (id) => {
        const upper = String(id).toUpperCase();
        const byUpper = {
            FDXE: 'FedEx',
            DHLGM: 'DHL eCommerce',
            ENDCA: 'USPS',
            PBCS: 'PitneyBowesStd',
            AMZN: 'Amazon Buy',
            TUSK: 'Tusk Logistics',
        };
        if (byUpper[upper]) return byUpper[upper];
        const lower = String(id).toLowerCase();
        if (lower === 'amazon_buy_shipping') return 'Amazon Buy';
        if (lower === 'amazon') return 'Amazon Shipping';
        if (lower === 'stallion') return 'Stallion Express';
        return null;
    };

    gridHasAccountForRateShoppingId = (id, gridData) => {
        if (!gridData || !gridData.length) return false;
        const idLower = String(id).toLowerCase();
        const idNormKey = this.normalizeCarrierKeyForRateShop(id);
        const legacyLabel = this.legacyRateShoppingIdToGridCarrierLabel(id);
        const schema = GlobalService.GetDynamicCarrierAccountSchema();

        return gridData.some((row) => {
            if (!row.Carrier) return false;
            const keys = this.getSchemaCarrierKeysForGridRow(row);
            for (const key of keys) {
                if (key.toLowerCase() === idLower || this.normalizeCarrierKeyForRateShop(key) === idNormKey) {
                    return true;
                }
                if (schema) {
                    for (const p in schema) {
                        const def = schema[p]?.carriers?.[key];
                        if (def?.carrierName && def.carrierName.toLowerCase() === idLower) return true;
                    }
                }
            }
            if (row.Carrier.toLowerCase() === idLower) return true;
            if (
                legacyLabel &&
                this.removeSpecialCharacters(row.Carrier.toLowerCase()) ===
                    this.removeSpecialCharacters(legacyLabel.toLowerCase())
            ) {
                return true;
            }
            return false;
        });
    };

    /** Remove SmallParcelRateShoppingCarrierIds that have no matching carrier account row (e.g. after delete). */
    reconcileRateShoppingCarrierIdsWithGrid = (settings, gridData) => {
        const tempSharedSmallParcelSettings = Object.assign({}, settings);
        if (!tempSharedSmallParcelSettings.SmallParcelRateShoppingCarrierIds) {
            return { settings: tempSharedSmallParcelSettings, changed: false };
        }
        const ids = tempSharedSmallParcelSettings.SmallParcelRateShoppingCarrierIds.split(',').map((x) => x.trim()).filter(Boolean);
        const kept = ids.filter((id) => this.gridHasAccountForRateShoppingId(id, gridData));
        if (kept.length === ids.length) {
            return { settings: tempSharedSmallParcelSettings, changed: false };
        }
        tempSharedSmallParcelSettings.SmallParcelRateShoppingCarrierIds = kept.join(',');
        return { settings: tempSharedSmallParcelSettings, changed: true };
    };

    /**
     * Same serialization as manual Save (needed because the API expects full `spsData`).
     * Only `SmallParcelRateShoppingCarrierIds` / derived carrier-accounts fields differ when reconciled after grid refresh.
     */
    prepareSettingsDataForApi = (sharedSettings, carrierAccountsGridData) => {
        // SmallParcelDefaultCartonLabel stays on the save blob for carton printing
        // when SmallParcelUseNewUcc128Features is off. The UCC-128 flag and PAPI
        // template fields are saved with the rest of spsData.
        let settingsData = Object.assign({}, sharedSettings);

        if (Array.isArray(settingsData.SmallParcelRateShoppingLogic)) {
            settingsData.SmallParcelRateShoppingLogic = GridConfig.sanitizeRateShoppingLogic(
                settingsData.SmallParcelRateShoppingLogic
            );
        }
        settingsData.SmallParcelRateShoppingLogic = JSON.stringify(settingsData.SmallParcelRateShoppingLogic);
        if (!this.isEnableProvider) {
            if (settingsData.SmallParcelUsps3rdParty == null || settingsData.SmallParcelUsps3rdParty == '') {
                if (settingsData.SmallParcelRateShoppingCarrierIds != null) {
                    let tempArr = settingsData.SmallParcelRateShoppingCarrierIds.split(',');
                    let position = tempArr.indexOf('ENDCA');
                    (position != -1) ? tempArr.splice(position, 1) : '';
                    settingsData.SmallParcelRateShoppingCarrierIds = tempArr.join(',');
                }
            }
        }

        settingsData.SmallParcelReferences = '';

        if (settingsData.SmallParcelRateShoppingCarrierIds && settingsData.SmallParcelRateShoppingCarrierIds !== '') {
            let carrierIds = settingsData.SmallParcelRateShoppingCarrierIds.split(',');
            let selectedCarrierAccounts = settingsData.SmallParcelRateShoppingCarrierAccounts
                ? settingsData.SmallParcelRateShoppingCarrierAccounts.split(',')
                : [];
            let tempSelectedCarrierAccounts = [];
            for (let i = 0; i < carrierIds.length; i++) {
                let carrierName = carrierIds[i];
                if (carrierName === 'DHLGM') {
                    carrierName = 'DHL eCommerce';
                } else if (carrierName === 'FDXE') {
                    carrierName = 'FedEx';
                } else if (carrierName === 'ENDCA') {
                    carrierName = 'USPS';
                } else if (carrierName === 'PBCS') {
                    carrierName = 'PitneyBowesStd';
                } else if (carrierName === 'AMZN' || carrierName === 'amazon_buy_shipping') {
                    carrierName = 'Amazon Buy';
                } else if (carrierName === 'amazon') {
                    carrierName = 'Amazon Shipping';
                } else if (carrierName === 'stallion') {
                    carrierName = 'Stallion Express';
                } else if (carrierName === 'Tusk') {
                    carrierName = 'Tusk Logistics';
                } else if (carrierName === 'usaExportPbaAccount') {
                    carrierName = 'USA Export - Powered By Asendia';
                }
                (carrierAccountsGridData || []).filter((el) => {
                    if (
                        el.Carrier &&
                        this.removeSpecialCharacters(el.Carrier.toLowerCase()) ===
                            this.removeSpecialCharacters(carrierName.toLowerCase())
                    ) {
                        if (selectedCarrierAccounts.includes(el.AccountNumber)) {
                            tempSelectedCarrierAccounts.push(el.AccountNumber);
                        }
                    }
                });
            }
            settingsData.SmallParcelRateShoppingCarrierAccounts = tempSelectedCarrierAccounts.join(',');
        } else {
            settingsData.SmallParcelRateShoppingCarrierAccounts = '';
        }

        var settingsArray = [];

        if (settingsData.PieceShipRef && settingsData.PieceShipRef != '') {
            settingsArray.push('PieceShipRef:' + settingsData.PieceShipRef);
        }

        if (settingsData.PieceShipRef1 && settingsData.PieceShipRef1 != '') {
            settingsArray.push('PieceShipRef1:' + settingsData.PieceShipRef1);
        }

        if (settingsData.PieceShipRef2 && settingsData.PieceShipRef2 != '') {
            settingsArray.push('PieceShipRef2:' + settingsData.PieceShipRef2);
        }

        if (settingsData.PieceShipRef3 && settingsData.PieceShipRef3 != '') {
            settingsArray.push('PieceShipRef3:' + settingsData.PieceShipRef3);
        }

        if (settingsData.PieceShipRef4 && settingsData.PieceShipRef4 != '') {
            settingsArray.push('PieceShipRef4:' + settingsData.PieceShipRef4);
        }

        if (settingsArray.length > 0) {
            settingsData.SmallParcelReferences = settingsArray.join('|');
        }

        delete settingsData.PieceShipRef;
        delete settingsData.PieceShipRef1;
        delete settingsData.PieceShipRef2;
        delete settingsData.PieceShipRef3;
        delete settingsData.PieceShipRef4;

        delete settingsData.carrierFedEx;
        delete settingsData.carrierUPS;

        delete settingsData.Carrier;

        return settingsData;
    };

    /** After grid refresh, persist reconciled rate-shopping carrier ids (and derived carrier accounts) when they changed. */
    saveReconciledRateShoppingCarrierIdsFromGridLoad = (reconciledSettings, carrierGridData, custUri) => {
        const settingsData = this.prepareSettingsDataForApi(reconciledSettings, carrierGridData);
        return smallParcelServices
            .saveSmartParcelSettings({
                custUri: custUri,
                spsData: settingsData,
            })
            .then((response) => {
                if (response && response.status == 200) {
                    this.$rootScope.dirtyWindow[this.windowId] = false;
                    this.setState({ isFormDataChanged: false });
                }
            });
    };

    componentDidMount() {

        var eventName = "onDirtyWindowCloseSmallParcelSettings" + this.windowId;
        document.addEventListener(eventName, this.openConfirmModal);
        var closeEventName = "removeDirtyWindowCloseSmallParcelSettings" + this.windowId;
        var that = this;
        document.addEventListener(closeEventName, function handler(e) {
            document.removeEventListener(eventName, that.openConfirmModal);
            e.currentTarget.removeEventListener(e.type, handler);
            /* whatever */
        });
    }
    openConfirmModal = () => {
        this.setState({
            isOpenConfirmModel: true
        });
    }
    onCloseFunc = () => {
        this.setState({
            isOpenConfirmModel: false
        });
    }
    onDiscardAndExit = () => {
        this.setState({
            isOpenConfirmModel: false,
            isFormDataChanged: false
        });
        setTimeout(() => {
            this.$rootScope.dirtyWindow[this.windowId] = false;
            GlobalService.closeWindow(this.windowId);
            // remove event listener on close window
            var eventName = "onDirtyWindowCloseSmallParcelSettings" + this.windowId;
            document.removeEventListener(eventName, this.openConfirmModal);
        }, 100);
    }

    handleCustomerChange = (event) => {

        let customerObj = {};
        if (event.target.value) {
            customerObj = this.optionsCustomer[event.target.value];
            this.getSmartParcelSettingsAndCarrier(customerObj.uri);
        }
        this.setState({
            selectedCustomerIndex: event.target.value,
            selectedCustomerObj: customerObj,
            isInitializeSettings: false
        });

    }
    getSmartParcelSettingsAndCarrier = (customerUri, options = {}) => {

        kendo.ui.progress($('#' + this.windowId), true);
        smallParcelServices.getSmartParcelSettingsAndCarrier(customerUri).then((response) => {

            let tmpSharedSmallParcelSettings = {
                carrierFedEx: [],
                carrierUPS: [],
                AutoRateShoppingMapping: '',
                AutoRateShoppingLogic: '',
            };
            // Shallow-copy array so RowNumber mutation does not reuse the same reference; Smart Settings can detect adds/refreshes.
            let tmpCarrierAccountsGridData = GlobalService.addRowNumberField(
                (response.carrierAccountsResponse || []).slice()
            );

            // Saperate reference value in different property which have in below format
            // "PieceShipRef:RefNum|PieceShipRef1:TransId|PieceShipRef2:TransId|PieceShipRef3:TransId|PieceShipRef4:TransId"
            if (response.smartParcelSettingsOptionsResponse) {
                tmpSharedSmallParcelSettings = response.smartParcelSettingsOptionsResponse;

                if (tmpSharedSmallParcelSettings.SmallParcelReferences != null && tmpSharedSmallParcelSettings.SmallParcelReferences != "") {
                    let arr = tmpSharedSmallParcelSettings.SmallParcelReferences.split('|');
                    for (let i = 0; i < arr.length; i++) {
                        if (arr[i] != "") {
                            const splitKeyWithColon = arr[i].split(':');
                            tmpSharedSmallParcelSettings[splitKeyWithColon[0]] = splitKeyWithColon[1];
                        }
                    }
                }

                if (tmpSharedSmallParcelSettings.Carrier.length) {
                    for (let index = 0; index < tmpSharedSmallParcelSettings.Carrier.length; index++) {
                        const element = tmpSharedSmallParcelSettings.Carrier[index];
                        if (element.Carrier == "FedEx") {
                            tmpSharedSmallParcelSettings.carrierFedEx = element.ShipmentServices;
                        } else if (element.Carrier == "UPS") {
                            tmpSharedSmallParcelSettings.carrierUPS = element.ShipmentServices;
                        }
                    }
                }

                if (tmpSharedSmallParcelSettings.SmallParcelRateShoppingLogic) {
                    tmpSharedSmallParcelSettings.SmallParcelRateShoppingLogic = GridConfig.sanitizeRateShoppingLogic(
                        JSON.parse(tmpSharedSmallParcelSettings.SmallParcelRateShoppingLogic)
                    );
                }
            }

            if (response.shipEngineCarrierResponse.Carriers) {
                response.shipEngineCarrierResponse.Carriers = response.shipEngineCarrierResponse.Carriers;
            }

            const wasInitialized = this.state.isInitializeSettings;
            const idReconcile = this.reconcileRateShoppingCarrierIdsWithGrid(
                tmpSharedSmallParcelSettings,
                tmpCarrierAccountsGridData
            );
            tmpSharedSmallParcelSettings = idReconcile.settings;

            this.setState({
                sharedSmallParcelSettings: tmpSharedSmallParcelSettings,
                carrierAccountsGridData: tmpCarrierAccountsGridData,
                sharedShipEngineCarrier: response.shipEngineCarrierResponse.Carriers,
                isInitializeSettings: true,
                isFormDataChanged:
                    idReconcile.changed && wasInitialized && !options.persistReconciledIds
                        ? true
                        : this.state.isFormDataChanged,
            });

            if (idReconcile.changed && wasInitialized && !options.persistReconciledIds) {
                this.$rootScope.dirtyWindow[this.windowId] = true;
            }

            const shouldPersistReconciledIds =
                options.persistReconciledIds &&
                idReconcile.changed &&
                wasInitialized &&
                customerUri;

            if (shouldPersistReconciledIds) {
                this.saveReconciledRateShoppingCarrierIdsFromGridLoad(
                    tmpSharedSmallParcelSettings,
                    tmpCarrierAccountsGridData,
                    customerUri
                );
            }

        }).finally(() => {
            kendo.ui.progress($('#' + this.windowId), false);
        });
    }


    settingsDataSet = (param_setting_obj, options) => {
        const quiet = options && options.quiet;
        this.setState({
            sharedSmallParcelSettings: param_setting_obj,
            isFormDataChanged: quiet ? this.state.isFormDataChanged : true
        });
        if (!quiet) {
            this.$rootScope.dirtyWindow[this.windowId] = true;
        }
    }

    saveSmallParcelSettings = (isExitAfterSave) => (e) => {
        this.setState({ settingsSaveLoading: true });

        const settingsData = this.prepareSettingsDataForApi(
            this.state.sharedSmallParcelSettings,
            this.state.carrierAccountsGridData
        );

        const param_settings_data = {
            custUri: this.state.selectedCustomerObj.uri,
            spsData: settingsData,
        };

        smallParcelServices.saveSmartParcelSettings(param_settings_data).then((response) => {
            if (response && response.status == 200) {
                GlobalService.notification('success', this.translate('Window_Title_Label_SmartParcel_Data_Success'));
                this.$rootScope.dirtyWindow[this.windowId] = false;
                // Documents gates read SmallParcelPapiPackSlipScope from the session customer
                // list; patch so Per Order/Per Package takes effect without a full page reload.
                const savedCustomer = this.state.selectedCustomerObj;
                if (savedCustomer && savedCustomer.id != null) {
                    GlobalService.patchCustomerOptions(savedCustomer.id, {
                        smallParcelPapiPackSlipScope: settingsData.SmallParcelPapiPackSlipScope || "",
                        SmallParcelPapiPackSlipScope: settingsData.SmallParcelPapiPackSlipScope || "",
                        smallParcelPapiPackSlipTemplateId: settingsData.SmallParcelPapiPackSlipTemplateId || null,
                        SmallParcelPapiPackSlipTemplateId: settingsData.SmallParcelPapiPackSlipTemplateId || null,
                        smallParcelPapiPackSlipTemplateVersion: settingsData.SmallParcelPapiPackSlipTemplateVersion ?? null,
                        SmallParcelPapiPackSlipTemplateVersion: settingsData.SmallParcelPapiPackSlipTemplateVersion ?? null,
                        smallParcelPapiUcc128TemplateId: settingsData.SmallParcelPapiUcc128TemplateId || null,
                        SmallParcelPapiUcc128TemplateId: settingsData.SmallParcelPapiUcc128TemplateId || null,
                        smallParcelPapiUcc128TemplateVersion: settingsData.SmallParcelPapiUcc128TemplateVersion ?? null,
                        SmallParcelPapiUcc128TemplateVersion: settingsData.SmallParcelPapiUcc128TemplateVersion ?? null,
                        smallParcelPapiPackSlipFormat: settingsData.SmallParcelPapiPackSlipFormat || "",
                        SmallParcelPapiPackSlipFormat: settingsData.SmallParcelPapiPackSlipFormat || "",
                        smallParcelPapiUcc128Format: settingsData.SmallParcelPapiUcc128Format || "",
                        SmallParcelPapiUcc128Format: settingsData.SmallParcelPapiUcc128Format || "",
                        smallParcelUseNewPackingSlipFeatures: !!settingsData.SmallParcelUseNewPackingSlipFeatures,
                        SmallParcelUseNewPackingSlipFeatures: !!settingsData.SmallParcelUseNewPackingSlipFeatures,
                        smallParcelUseNewUcc128Features: !!settingsData.SmallParcelUseNewUcc128Features,
                        SmallParcelUseNewUcc128Features: !!settingsData.SmallParcelUseNewUcc128Features,
                        // SmallParcelDefaultCartonLabel stays on spsData via prepareSettingsDataForApi.
                        // Pack & Ship still prints .3zt carton labels from that field.
                    });
                }
                if (isExitAfterSave) {
                    this.onDiscardAndExit();
                }
                this.setState({ isFormDataChanged: false });
                this.refreshGridData();
            }
        }).finally(() => {
            this.setState({ settingsSaveLoading: false });
        });
    }

    refreshGridData = () => {
        const uri = this.state.selectedCustomerObj && this.state.selectedCustomerObj.uri;
        if (!uri) {
            return;
        }
        this.getSmartParcelSettingsAndCarrier(uri, { persistReconciledIds: true });
    }

    render() {
        return (
            <div className="small-parcel-settings-wrapper">

                <WmsButton
                    label={this.translate("Label_Save")}
                    wmsSelector={this.selector + "Save"}
                    onClickFunc={this.saveSmallParcelSettings(false)}
                    icon="fa-floppy-o"
                    showToolTip={this.state.selectedCustomerIndex == '' || this.state.isFormDataChanged == false}
                    tooltipText={
                        (this.state.selectedCustomerIndex == '') ?
                            this.translate("Label_Smart_Customer_Require_Tooltip") : this.translate("Tooltip_Save_Disabled")
                    }
                    loading={this.state.settingsSaveLoading}
                    disabled={this.state.selectedCustomerIndex == '' || this.state.isFormDataChanged == false}
                    parentClassName="small-parcel-settings-save-btn" />


                <WmsCollapse
                    id={'smallParcelSettingsCustomerSelection'}
                    headerLabel={this.translate('Label_Customer_Text')}
                    showCollapseText={false}
                    showCollapseIcon={true}>
                    <WmsDropdown
                        id="Customer"
                        name="smartParcelCustomer"
                        label={this.customLabels.Label_Customer}
                        wmsSelector={this.selector + "Customer"}
                        value={this.state.selectedCustomerIndex}
                        onChangeFunc={this.handleCustomerChange}
                        options={this.optionsCustomer}
                        valueField='uri'
                        textField='name'
                        blankFirstOption={true}
                        applyIndex={true}
                        blankFirstOptionText="Unspecified"
                        extraWrapperClass="customer-selection-wrapper" />
                </WmsCollapse>
                {this.state.isInitializeSettings && (
                    <div>

                        <SmallParcelCarrierAccountSettings
                            key={this.state.sharedSmallParcelSettings.SmallParcelRateShoppingCarrierAccounts}
                            selector={this.selector}
                            windowId={this.windowId}
                            sharedCarrierAccountsGridData={this.state.carrierAccountsGridData}
                            sharedFacilityOption={this.sharedFacilityOption}
                            sharedSmallParcelSettings={this.state.sharedSmallParcelSettings}
                            sharedSelectedCustomer={this.state.selectedCustomerObj}
                            onRefreshGridData={this.refreshGridData}
                            sharedShipEngineCarrier={this.state.sharedShipEngineCarrier} />

                        <SmallParcelSmartSettings
                            key={this.state.selectedCustomerObj && this.state.selectedCustomerObj.id}
                            selector={this.selector}
                            windowId={this.windowId}
                            sharedSmallParcelSettings={this.state.sharedSmallParcelSettings}
                            sharedCarrierAccountsGridData={this.state.carrierAccountsGridData}
                            sharedShipEngineCarrier={this.state.sharedShipEngineCarrier}
                            sharedSelectedCustomer={this.state.selectedCustomerObj}
                            onRefreshGridData={this.refreshGridData}
                            onSettingsDataSet={this.settingsDataSet} />

                    </div>
                )}
                <div>
                    <WmsConfirmModel
                        id={"ConfirmModel" + this.windowId}
                        isOpen={this.state.isOpenConfirmModel}
                        type={this.translate('Label_Confirmation')}
                        width={550}
                        height={175}
                        firstBtnLabel={this.translate('Label_Save_and_Exit')}
                        firstBtnIcon={"fa-check-square"}
                        firstBtnOnClickFunc={this.saveSmallParcelSettings(true)}
                        sawCheckBox={false}
                        extraWrapperClass={'wms-confirm-text-center'}
                        conFormModelText={this.translate('Label_are_you_sure_close_order')}
                        onCloseFunc={this.onCloseFunc}
                        thirdBtnLabel={this.translate('Label_Cancel')}
                        thirdBtnIcon={"fa-times-circle"}
                        thirdButtonType={"orange"}
                        isSecondBtnSaw={true}
                        secondFunctionClick={this.onDiscardAndExit}
                        secondBtnLabel={this.translate('Label_Discard_Exit')}
                        secondBtnIcon={"fa-times-circle"}
                    />
                </div>
            </div>
        );
    }
}